import { Col, Row } from "antd"
import React from "react"

const WATCH: string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABG0lEQVRIie2XwWrCQBCGvwpNb4J9q+Zi9S59AxV6aF+kPpFCb/XiQfsGelCvBrWHzFIRVmd2N6DiD8NCMv98ZJPszsKVKAe+gQVQSMzlWl4VtAGsgb0n1pKjUs0AfgPqJ+7XgY6hnkqPwC/+p3Uxk9xk6iugLnqpoC1gaQAvxROlNrAzQF3sYuFjKfQBZIr8DPgUz08MeCNFNNBD+F68wXJTF+ob+hIeFAU0eT6f12tZQJKqavAo1Bj7jr262am+gy8fXMhoWTKfjrxB4ImM70p4JrmH3iC1CNsWt8BrDBgpYG0EmrFQp54B3E0FhbKBmymgU5TNnvZ3KoCBIu+LM19ziJ453dCvMDT0VrkjzJyytdnwf4R5qQqaVH/xCZe9Dt3NEwAAAABJRU5ErkJggg=="

export const TrayMain = (props: { countBC: number, countBL: number, trayId: string | undefined }) => (
  <Row className='tray-main'>
    <Col xs={14}>
      <h2>
        Plateau
      </h2>
      <div>
        {props.trayId}
      </div>
    </Col>
    <Col xs={8}>
      <div className='tray-count'>
        {props.countBC > 0 ? props.countBC : props.countBL}
        <img alt="" className='watch-icon' src={WATCH} />
      </div>
    </Col>
  </Row>
)